


import React from 'react';
import partnerVideo from '../img/envision/aerospace/energy1.mp4'; // Replace with the correct path to your video file

const DocumentEnergyBanner = () => {
    return (
        <div style={{ position: 'relative', height: '750px', width: '100%' }}>
            {/* Text Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                    flexDirection:'column'
                }}
            >
                <h1 style={{ margin: 0, textAlign: 'center', fontSize:'26px' }}>Revolutionizing the Energy & Infrastructure sectors  <br></br> with cutting-edge security, sustainable innovation, and operational resilience </h1>
                {/* <p style={{marginTop:'10px'}}>Delivering autonomous product and sustainable plant engineering lifecycle solutions</p>
             */}
            </div>

            {/* Video */}
            <video
                src={partnerVideo}
                alt="partner video"
                autoPlay
                loop
                muted
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'cover', // This will ensure the video covers the area without stretching
                }}
            />
        </div>
    );
};

export default DocumentEnergyBanner;
